import { UPDATE_PAGINATION } from "Redux/Actions/paginationActions";

const INITIAL_STATE = {
  currentPage: 1,
  paginationBasicFirst: 0,
  paginationBasicRows: 12,
};

const paginationReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case UPDATE_PAGINATION: {
      return {
        ...state,
        ...action.value,
      };
    }
    default:
      return state;
  }
};

export default paginationReducer;
